<ng-content select="[orderby]"></ng-content>
<ng-content select="area"></ng-content>
<ng-content select="instructor"></ng-content>
<ng-content select="softwares"></ng-content>
<div
  class="filter-bottomsheet-option-list-wrapper"
  [ngClass]="isOptionsContainsIcons && 'options-with-icons'"
>
  <div class="filter-bottomsheet-search-input" *ngIf="showInputSearch">
    <input
      type="text"
      [formControl]="searchText"
      [placeholder]="placeholderInput"
    />
  </div>
  <div class="filter-bottomsheet-confirm-button" *ngIf="isShowContinueButton">
    <button
      class="confirm-button"
      (click)="handleApplyFilter()"
      [disabled]="!options.length"
    >
      Continuar
    </button>
  </div>
  <ng-container *ngIf="identifier === 'orderby'">
    <div [ngStyle]="{ display: isRadio ? 'block' : 'none' }">
      <unh-radio
        *ngFor="let option of options; index as i"
        [checked]="option.title === selectedOrderBy"
        [label]="option.title"
        [checkIcon]="option.icon"
        groupName="orderby-filter"
        (unhChange)="changeOrderBy(option)"
      >
        <img
          src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/course-admin/check-course-admin-icon.svg"
        />
      </unh-radio>
    </div>
  </ng-container>
  <ng-container *ngIf="identifier !== 'orderby'">
    <unh-checkbox
      *ngFor="let option of filteredOptions; index as i"
      [checked]="option.value"
      [blocked]="false"
      [label]="option.title"
      [checkIcon]="option.icon"
      (unhChange)="updateSelecteds(option)"
    >
      <img
        src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/course-admin/check-course-admin-icon.svg"
      />
    </unh-checkbox>
  </ng-container>
</div>
